import * as React from "react";
import { triangulatePolygon } from "./utils";
import { WebGLContext } from "../CanvasGL";
import { v4 as uuid } from "uuid";
import { hexToRgbA } from "../CanvasGL/utils";
import { useEffect, useMemo } from "react";
import { useAttributes, useShaders } from "../CanvasGL/hooks";
export const AreaGL = (props) => {
    const id = React.useRef(uuid());
    const { domainX, domainY, color, show } = props;
    const { canvas, areaShaders, requestUpdate } = React.useContext(WebGLContext);
    const { shaderProgram } = useShaders(canvas, areaShaders.vertexShader, areaShaders.fragmentShader);
    const { xy } = props;
    const { attributes, items } = useMemo(() => {
        const values = triangulatePolygon(xy);
        return {
            attributes: [
                {
                    name: "aCurrent",
                    index: 2,
                    buffer: canvas.createBuffer(),
                    values,
                },
            ],
            items: values.length / 2,
        };
    }, [xy]);
    useAttributes(canvas, shaderProgram, attributes, items, id.current, canvas.TRIANGLES);
    useUniforms(canvas, shaderProgram, show ? 1.0 : 0.0, domainX, domainY, color, requestUpdate);
    return null;
};
export const useUniforms = (gl, shaderProgram, thickness, domainX = [0, 1], domainY = [0, 1], color = "#000", requestUpdate) => {
    const canvas = gl.canvas;
    const correctedThickness = thickness / (canvas === null || canvas === void 0 ? void 0 : canvas.height) || thickness / 400;
    useEffect(() => {
        if (!shaderProgram)
            return;
        const rgbaColor = hexToRgbA(color);
        gl.useProgram(shaderProgram);
        const pUniformDomainX = gl.getUniformLocation(shaderProgram, "uDomainX");
        gl.uniform2fv(pUniformDomainX, domainX);
        const pUniformDomainY = gl.getUniformLocation(shaderProgram, "uDomainY");
        gl.uniform2fv(pUniformDomainY, domainY);
        const pUniformColor = gl.getUniformLocation(shaderProgram, "uColor");
        gl.uniform4fv(pUniformColor, rgbaColor);
        const pUniformThickness = gl.getUniformLocation(shaderProgram, "uThickness");
        gl.uniform1f(pUniformThickness, correctedThickness);
        requestUpdate();
    }, [gl, shaderProgram, correctedThickness, domainX, domainY, color]);
};
//# sourceMappingURL=index.js.map